import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';

import {apiUrl} from "../../../../libs/api";
import createLink from "../../../../libs/createLink";

import {stringify} from "query-string/index";
import {isNoFollowAlbum, isNoFollowArticle, isNoFollowMedia} from "../../../../libs/helper";

import pictureLogo from '../../../../images/logo.png';
import {apiCropImage} from "../../../../config";
import ImageRotation from "../../ImageRotation";


const Album = (props) =>{
    let relLink = isNoFollowAlbum(props.album) ? { rel: "nofollow" } : {};
    return (
        <Link
              {...relLink}
              to={createLink("userAlbum", {...props.album.owner, album : {_id : props.album._id, slug : props.album.slug}})}
              target={"_blank"}
              className={"draft-shared-media album"}
              data-id={props.album._id}
        >
            <div className={"content"} style={{backgroundImage: `url(${props.albumMedia?.previewUrl ? props.albumMedia.previewUrl+"?width=350&height=200&quality=100" : pictureLogo})`}} />
            <div className={"caption"}>{props.album.title}</div>
        </Link>
    )
}

const Article = (props) =>{
    let relLink = isNoFollowArticle(props.article) ? { rel: "nofollow" } : {};
    return (
        <Link
            {...relLink}
            to={createLink("article", {...props.article.owner, article : {_id : props.article._id, slug : props.article.slug}})}
            target={"_blank"}
            className={"draft-shared-media article"}
            data-id={props.article._id}
        >
            <div className={"content"} style={{backgroundImage: `url(${props.article.cover ? `${props.article.cover}?width=350&height=200&quality=100` : pictureLogo})`}} />
            <div className={"caption"}>{props.article.title}</div>
        </Link>
    )
}

const Photo = (props) =>{
    let relLink = isNoFollowMedia(props.media) ? { rel: "nofollow" } : {};
    return (
        <Link
            {...relLink}
            to={createLink("mediaviewerPhoto", props)}
            target={"_blank"}
            data-id={props.media._id}
            className={"draft-shared-media media"}
        >
            <div className={`content`}>
                <img alt={props.media.title} src={props.media.previewUrl ? `${props.media.previewUrl}?width=350&height=200&quality=100` : pictureLogo} />
            </div>
            <div className={"caption"}>{props.media.title}</div>
        </Link>
    )
}

const Video = (props) =>{
    let relLink = isNoFollowMedia(props.media) ? { rel: "nofollow" } : {};
    return (
        <Link
            {...relLink}
            to={createLink("mediaviewerVideo", props)}
            target={"_blank"}
            data-id={props.media._id}
            className={"draft-shared-media media"}
        >
            <div className={`content`}>
                <ImageRotation
                    srcs={Array.isArray(props.media.previewUrl) && props.media.previewUrl.map(src => apiCropImage({
                        url: src,
                        width: 350,
                        height: 200
                    }))}
                    interval={600}
                    alt={props.media.title}
                />
            </div>
            <div className={"caption"}>{props.media.title}</div>
        </Link>
    )
}


export default class DraftSharedMedia extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            album : {},
            albumMedia: {},
            media: {},
            article: {},
            noAlbumCover: false,
            error: false,
        }

    }

    componentDidMount() {
        if(this.props.kind === "album"){
            apiUrl.get(`albums/${this.props._id}`).then(response => {
                this.setState({album: response});
                apiUrl.get(`albums/${this.props._id}/medias?${stringify({
                    byAlbumId: this.props._id,
                    sort: "-createdAt",
                    kind : "gallery",
                    limit: 1,
                    throwError: false
                })}`).then(response => {
                    if(response === null){
                        this.setState({error: true})
                    } else {
                        this.setState({albumMedia : response.data[0]});
                    }
                }).catch(e => {
                    this.setState({noAlbumCover: true});
                })
            }).catch( e => {
                this.setState({error: true});
            })
        } else if (this.props.kind === "media" || this.props.kind === "gallery") {
            apiUrl.get(`medias/${this.props._id}`).then(response => {
                if(response === null){
                    this.setState({error: true})
                } else {
                    this.setState({media: response});
                }
            }).catch( e => {
                this.setState({error: true});
            })
        } else if (this.props.kind === "articles" || this.props.kind === "blog") {
            apiUrl.get(`articles/${this.props._id}`).then(response => {
                if(response === null){
                    this.setState({error: true})
                } else {
                    this.setState({article: response});
                }
            }).catch( e => {
                this.setState({error: true});
            })
        }
    }

    render(){
        //console.log(this.contentRef);
//console.log(this.state);
        return this.state.error ? (
            <div className={"draft-shared-media error"}>
                Vous n'avez pas accès à ce contenu
            </div>
        ) : (
            <Fragment >
                {this.props.kind === "album" && this.state.album._id && (
                    <Album album={this.state.album} albumMedia={this.state.albumMedia} />
                )}
                {(this.props.kind === "media" || this.props.kind === "gallery") && this.state.media._id && (
                    this.state.media?.kind === "video" ? <Video media={this.state.media} /> : <Photo media={this.state.media} />
                )}
                {(this.props.kind === "articles" || this.props.kind === "blog") && this.state.article._id && (
                    <Article article={this.state.article} />
                )}
            </Fragment>
        )
    }
}